import useResizeLayout from '@Hooks/useResizeLayout';

interface ViewResolverProps {
  desktop: JSX.Element | null;
  mobile: JSX.Element | null;
  label?: string;
}

const ViewResolver: React.FC<ViewResolverProps> = ({ desktop, mobile }) => {
  const { isMobile } = useResizeLayout();
  return isMobile ? mobile : desktop;
};

export default ViewResolver;
